<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.workflowId"
              max-length="100"
              style="width:100%;"
              :readonly="true"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="openWorkflowPopup"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.workflowName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_PRC_TASK_STNRD_ID')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="frame0.processTaskStandardId"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>       
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_MDLE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.moduleName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_WKFL_CNTN')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <div class="comm_label">
              {{ frame0.workflowExplanationContent }}
            </div>
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SEARCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <div class="">
        <sui-diagram
          :model="diagramModel"
          :width="canvasWidth"
          :height="canvasHeight"
        />
      </div>
      <sui-popup
        v-model="isShownWorkflowPopup"
        :title="$t('MSG_TIT_WKFL_SELT')"
      >
        <p01
          :pageId="this.$options.name"
          :selectWorkflow="selectWorkflowCallback"
          @close="closeWorkflowPopup()"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
// eslint-disable-next-line import/no-unresolved
import BasePage from '~cm/components/BasePage';
// eslint-disable-next-line import/no-unresolved
import Diagram from '~common/components/form/SuiDiagram/components/SuiDiagram';
import p01 from './components/PGE_CMR_00006_P01';

export default {
  name: 'PGE_CMR_00006', // eslint-disable-line vue/name-property-casing
  components: {
    p01,
  },
  extends: BasePage,
  data() {
    return {
      diagramModel: new Diagram.Model(),
      canvasWidth: 1200,
      canvasHeight: 600,
      isShownWorkflowPopup: false,
      frame0: {
        workflowId: '',
        processTaskStandardId: '',
        workflowName: '',
        moduleName: '',
        workflowExplanationContent: '',
      },
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [],
  mounted() {
    // const node1 = this.diagramModel.addNode("페이지 생성", 100, 200, 200, 100);
    // const node2 = this.diagramModel.addNode("데이터서비스 등록", 400, 100, 200, 100);
    // const node3 = this.diagramModel.addNode("메시지리소스 등록", 400, 300, 200, 100);
    // const node4 = this.diagramModel.addNode("페이지 컴포넌트 등록", 700, 200, 200, 100);
    //
    // this.diagramModel.addLink(node1.addOutPort(""), node2.addInPort(""));
    // this.diagramModel.addLink(node1.addOutPort(""), node3.addInPort(""));
    // this.diagramModel.addLink(node2.addOutPort(""), node4.addInPort(""));
    // this.diagramModel.addLink(node3.addOutPort(""), node4.addInPort(""));
    //
    // node1.color = "#cc6666";
    // node2.color = "#cc6600";
    // node3.color = "#00cc66";
    // node4.color = "#00cc66";

  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onResetClick() {
      this.frame0.workflowId = '';
      this.frame0.processTaskStandardId = '';
      this.frame0.workflowName = '';
      this.frame0.moduleName = '';
      this.frame0.workflowExplanationContent = '';
      this.diagramModel = new Diagram.Model();
    },
    onSearchClick() {
      if (this.frame0.workflowId) {
        this.diagramModel = new Diagram.Model();
        http.request(this.$options.name, 'DTS_CMR_00021', {
          path: { 'workflow-id': this.frame0.workflowId },
          query: {
            processTaskStandardId: this.frame0.processTaskStandardId,
            canvasWidth: this.canvasWidth,
            canvasHeight: this.canvasHeight,
          },
        }).then(res => {
          console.log(res);
          const nodeMap = {};
          const { nodeList } = res.data;
          nodeList.forEach(node => {
            nodeMap[node.nodeId] = this.diagramModel.addNode(node.nodeName, node.posX, node.posY, node.width, node.height);
            nodeMap[node.nodeId].color = (node.processYn === 'Y') ? '#cc6666' : '#00cc66';
            if (node.processYn === 'Y') {
              nodeMap[node.nodeId].performUser = node.performUser;
              nodeMap[node.nodeId].performDate = node.performDate;
            }
          });
          nodeList.forEach(node => {
            node.nextNodeId.forEach(nextNodeId => {
              this.diagramModel.addLink(nodeMap[node.nodeId].addOutPort(''), nodeMap[nextNodeId].addInPort(''));
            });
          });
        });
      }
    },
    openWorkflowPopup() {
      this.isShownWorkflowPopup = true;
    },
    closeWorkflowPopup() {
      this.isShownWorkflowPopup = false;
    },
    selectWorkflowCallback(workflowInfo) {
      this.frame0.workflowId = workflowInfo.workflowId;
      this.frame0.processTaskStandardId = workflowInfo.processTaskStandardId;
      this.frame0.workflowName = workflowInfo.workflowName;
      this.frame0.moduleName = workflowInfo.moduleName;
      this.frame0.workflowExplanationContent = workflowInfo.workflowExplanationContent;
    },
    openProcessPopup() {
      utils.openLayerPopup('PGE_CMR_00007', this.onProcessPopupCallback, {
        pageInitialData: {
          workflowId: 'WORK_001',
          processTaskStandardId: 'PGE_CMR_00001',
        },
        size: 'xlg',
      });
    },
    onProcessPopupCallback() {

    },


  },
};
</script>
<style scoped>
</style>
